import {dashboardTabId} from '../../../../../../../util/uiconstants';
import {DASHBOARD_VIEWS, HAS_EXTERNAL, PROJECT_OWNER_ACCESS} from '../utils/constants';

export default (values, userList) => {
	const hasExternal = userList.some(({isInternal}) => !isInternal);
	const newViews = values[DASHBOARD_VIEWS].map((view) => {
		if (hasExternal) {
			if (view.id === dashboardTabId.projectManagement || view.id === dashboardTabId.insights) {
				return {...view, disabled: hasExternal, checked: false};
			}
		}

		if (values[PROJECT_OWNER_ACCESS]) {
			return {...view, disabled: false, checked: true};
		}

		return {...view};
	});
	return {[HAS_EXTERNAL]: hasExternal, [DASHBOARD_VIEWS]: newViews};
};
